import styled from 'styled-components';

export const TextWithIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;
`;
